<div class="content">
    <div class="header">
        <div>
            <p>New arrivals</p>
            <h2>Fresh pieces for your next routine.</h2>
        </div>
        <a routerLink="/collection/{{newArrivalsNo}}" aria-label="New Activewear Products">View All
            <mat-icon fontSet="material-symbols-outlined" inline>arrow_forward</mat-icon>
        </a>
    </div>
    <div class="items" [attr.aria-busy]="loading">
        @if (loading) {
        @for (_ of loadingPlaceholders; track $index) {
        <div class="product-skeleton" aria-hidden="true">
            <span class="skeleton skeleton-image"></span>
            <span class="skeleton skeleton-line"></span>
            <span class="skeleton skeleton-line short"></span>
        </div>
        }
        } @else if (items.length) {
        @for (item of items; track $index) {
        <app-product-list-item [data]="item" [showTitle]="false" showleft
            [showDelay]="50+100*$index"></app-product-list-item>
        }
        } @else {
        <a class="empty-state" routerLink="/search" aria-label="Browse Veyora Fit activewear">
            <span>Shop the activewear edit</span>
            <mat-icon fontSet="material-symbols-outlined" inline>arrow_forward</mat-icon>
        </a>
        }
    </div>
</div>
